'use client'
import React, { useState, useEffect } from 'react'
import { Search, Plus, Edit3, Trash2, AlertTriangle, Filter, RefreshCw } from 'lucide-react'
import { socket } from '../Containers/MainContainer'

// Mock socket for demonstration


function PlutoSuspectOffers() {
  const [offers, setOffers] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [searchTerm, setSearchTerm] = useState('')
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [modalType, setModalType] = useState('add') // 'add' or 'edit'
  const [selectedOffer, setSelectedOffer] = useState(null)
  
  // Form states
  const [formData, setFormData] = useState({
    name: '',
    pendingDays: 0,
    condition: 'none',
    conditionReason: '',
    reqHold: 0.4
  })

  useEffect(() => {
    loadOffers()
  }, [])

  const loadOffers = () => {
    setLoading(true)
    socket.on('response_get_admin_bad_offers', (data) => {
      setOffers(data.withdrawals)
      setTotalCount(data.withdrawalsLength)
      setTotalPages(Math.ceil(data.withdrawalsLength / 5))
      setLoading(false)
    })
    
    socket.emit('getSuspectOffersAdmin', {
      offers_like: searchTerm,
      page: currentPage,
    })
  }

  const handleSearch = (value) => {
    setSearchTerm(value)
    setCurrentPage(1)
    setLoading(true)
    // Trigger search
    socket.emit('getSuspectOffersAdmin', {
      offers_like: value.toLowerCase(),
      page: 1,
    })
  }

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setLoading(true)
    socket.emit('getSuspectOffersAdmin', {
      offers_like: searchTerm,
      page: page,
    })
  }

  const openModal = (type, offer = null) => {
    setModalType(type)
    setSelectedOffer(offer)
    
    if (type === 'edit' && offer) {
      setFormData({
        name: offer.name,
        pendingDays: parseInt(offer.pending_time.replace(' days', '')),
        condition: offer.codition || 'none',
        conditionReason: offer.codition_action || '',
        reqHold: offer.req_hold || 0.4
      })
    } else {
      setFormData({
        name: '',
        pendingDays: 0,
        condition: 'none',
        conditionReason: '',
        reqHold: 0.4
      })
    }
    
    setShowModal(true)
  }

  const handleSubmit = () => {
    if (formData.name.length > 2 && formData.pendingDays >= 0 && formData.reqHold >= 0.01 && formData.reqHold <= 1) {
      if (modalType === 'add') {
        socket.emit('adminAction', {
          action: 'add_pending_offer',
          name: formData.name,
          days: formData.pendingDays,
          condition: formData.condition,
          condition_action: formData.conditionReason,
        })
      } else {
        socket.emit('adminAction', {
          action: 'edit_pending_offer',
          id: selectedOffer.id,
          name: formData.name,
          days: formData.pendingDays,
          req_hold: formData.reqHold,
          condition: formData.condition,
          condition_action: formData.conditionReason,
        })
      }
      setShowModal(false)
      setTimeout(()=>{
loadOffers()
      },500)
    }
  }

  const handleDelete = () => {
    socket.emit('adminAction', {
      action: 'delete_pending_offer',
      id: selectedOffer.id
    })
    setShowDeleteModal(false)
    setShowModal(false)
     setTimeout(()=>{
loadOffers()
      },500)
  }

  const getStatusBadge = (active) => {
    return active === 'Yes' ? 
      <span className="px-1 py-1 text-xs rounded-full bg-green-100 text-green-800 font-medium">Active</span> :
      <span className="px-1 py-1 text-xs rounded-full bg-red-100 text-red-800 font-medium">Inactive</span>
  }

  const getHoldBadge = (hold) => {
    return hold === 'Yes' ? 
      <span className="px-2 py-1 text-xs rounded-full bg-yellow-100 text-yellow-800 font-medium">Hold</span> :
      <span className="px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-800 font-medium">Released</span>
  }

  return (
    <div className="min-h-screen bg-gray-900 p-6 ">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-white">Suspect Offers Management</h1>
              <p className="text-gray-400 mt-2">Monitor and manage flagged offers and their conditions</p>
            </div>
            <button
              onClick={() => openModal('add')}
              className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              <Plus size={20} />
              Add New Offer
            </button>
          </div>
        </div>

        {/* Stats Card */}
        <div className="bg-gray-800 rounded-xl shadow-sm border border-gray-700 p-6 mb-6">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-orange-900 rounded-lg">
              <AlertTriangle className="text-orange-400" size={24} />
            </div>
            <div>
              <div className="text-2xl font-bold text-white">{totalCount.toLocaleString()}</div>
              <div className="text-gray-400">Total Suspect Offers</div>
            </div>
          </div>
        </div>

        {/* Search and Filters */}
        <div className="bg-gray-800 rounded-xl shadow-sm border border-gray-700 p-6 mb-6">
          <div className="flex items-center gap-4">
            <div className="relative flex-1 max-w-md">
              <Search className="absolute left-3 top-1/4 transform -translate-y-1/2 text-gray-400" size={20} />
              <input
                type="text"
                placeholder="Search by offer name..."
                className="w-full pl-10 pr-4 py-2 bg-gray-700 border border-gray-600 text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400"
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
           
          </div>
        </div>

        {/* Table */}
        <div className="bg-gray-800 rounded-xl shadow-sm border border-gray-700 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-900 border-b border-gray-700">
                <tr>
                  <th className="text-left py-4 px-6 font-semibold text-gray-200">Offer Name</th>
                  <th className="text-left py-4 px-6 font-semibold text-gray-200">Reason</th>
                  <th className="text-left py-4 px-6 font-semibold text-gray-200">Hold Time</th>
                  <th className="text-left py-4 px-6 font-semibold text-gray-200">Status</th>
                  <th className="text-left py-4 px-6 font-semibold text-gray-200">Hold Status</th>
                  <th className="text-left py-4 px-6 font-semibold text-gray-200">Condition</th>
                  <th className="text-left py-4 px-6 font-semibold text-gray-200">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-700">
                {loading ? (
                  [...Array(5)].map((_, i) => (
                    <tr key={i}>
                      <td className="py-4 px-6">
                        <div className="h-4 bg-gray-700 rounded animate-pulse"></div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="h-4 bg-gray-700 rounded animate-pulse"></div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="h-4 bg-gray-700 rounded animate-pulse"></div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="h-4 bg-gray-700 rounded animate-pulse"></div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="h-4 bg-gray-700 rounded animate-pulse"></div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="h-4 bg-gray-700 rounded animate-pulse"></div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="h-8 w-16 bg-gray-700 rounded animate-pulse"></div>
                      </td>
                    </tr>
                  ))
                ) : (
                  offers.map((offer) => (
                    <tr key={offer.id} className="hover:bg-gray-750 transition-colors">
                      <td className="py-4 px-6">
                        <div className="font-medium text-white">{offer.name}</div>
                      </td>
                      <td className="py-4 px-6">
                        <div className="text-gray-300 max-w-xs truncate" title={offer.reason}>
                          {offer.reason}
                        </div>
                      </td>
                      <td className="py-4 px-6">
                        <span className="text-white font-medium">{offer.pending_time}</span>
                      </td>
                      <td className="py-4 px-6">
                        {getStatusBadge(offer.active)}
                      </td>
                      <td className="py-4 px-6">
                        {getHoldBadge(offer.hold)}
                      </td>
                      <td className="py-4 px-6">
                        <div className="text-sm text-gray-300">
                          {offer.codition == 'minute' || offer.condition == '1' ? `${offer.codition_action} min` : 'None'}
                        </div>
                      </td>
                      <td className="py-4 px-6">
                        <button
                          onClick={() => openModal('edit', offer)}
                          className="flex items-center gap-1 px-3 py-1.5 bg-blue-900 text-blue-200 rounded-lg hover:bg-blue-800 transition-colors text-sm font-medium"
                        >
                          <Edit3 size={14} />
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

{totalPages > 1 && !loading && (
          <div className="mt-6 flex justify-center">
            <div className="flex items-center gap-2">
              <button
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
                className="px-3 py-2 text-gray-300 bg-gray-800 border border-gray-600 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-700 transition-colors"
              >
                Previous
              </button>
              
              {/* Page numbers with smart truncation */}
              {(() => {
                const pages = []
                const showEllipsis = totalPages > 7
                
                if (!showEllipsis) {
                  // Show all pages if 7 or fewer
                  for (let i = 1; i <= totalPages; i++) {
                    pages.push(i)
                  }
                } else {
                  // Smart pagination for many pages
                  if (currentPage <= 4) {
                    // Show first 5 pages, ellipsis, last page
                    for (let i = 1; i <= 5; i++) pages.push(i)
                    if (totalPages > 6) pages.push('...')
                    pages.push(totalPages)
                  } else if (currentPage >= totalPages - 3) {
                    // Show first page, ellipsis, last 5 pages
                    pages.push(1)
                    if (totalPages > 6) pages.push('...')
                    for (let i = totalPages - 4; i <= totalPages; i++) pages.push(i)
                  } else {
                    // Show first, ellipsis, current-1, current, current+1, ellipsis, last
                    pages.push(1)
                    pages.push('...')
                    for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i)
                    pages.push('...')
                    pages.push(totalPages)
                  }
                }
                
                return pages.map((page, index) => {
                  if (page === '...') {
                    return (
                      <span key={`ellipsis-${index}`} className="px-3 py-2 text-gray-400">
                        ...
                      </span>
                    )
                  }
                  
                  return (
                    <button
                      key={page}
                      onClick={() => handlePageChange(page)}
                      className={`px-3 py-2 rounded-lg transition-colors ${
                        currentPage === page
                          ? 'bg-blue-600 text-white'
                          : 'text-gray-300 bg-gray-800 border border-gray-600 hover:bg-gray-700'
                      }`}
                    >
                      {page}
                    </button>
                  )
                })
              })()}
              
              <button
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
                className="px-3 py-2 text-gray-300 bg-gray-800 border border-gray-600 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-700 transition-colors"
              >
                Next
              </button>
            </div>
          </div>
        )}

        {/* Pagination Info */}
        {!loading && offers.length > 0 && (
          <div className="mt-4 text-center text-sm text-gray-400">
            Showing {((currentPage - 1) * 5) + 1} to {Math.min(currentPage * 5, totalCount)} of {totalCount} offers
          </div>
        )}
      </div>

  {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-gray-800 rounded-xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto border border-gray-700">
            <div className="p-6">
              <h3 className="text-xl font-bold text-white mb-6">
                {modalType === 'add' ? 'Add New Offer' : 'Edit Offer'}
              </h3>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Offer Name
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value.toLowerCase()})}
                    placeholder="Enter offer name"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Pending Days
                  </label>
                  <select
                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    value={formData.pendingDays}
                    onChange={(e) => setFormData({...formData, pendingDays: parseInt(e.target.value)})}
                  >
                    <option value={0}>0</option>
                    <option value={7}>7</option>
                    <option value={15}>15</option>
                    <option value={30}>30</option>
                    <option value={45}>45</option>
                    <option value={60}>60</option>
                    <option value={90}>90</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Condition Type
                  </label>
                  <select
                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    value={formData.condition}
                    onChange={(e) => setFormData({...formData, condition: e.target.value})}
                  >
                    <option value={'0'}>None</option>
                    <option value={'1'}>Minutes</option>
                  </select>
                </div>

                {formData.condition == 'minute' || formData.condition == '1' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-300 mb-2">
                      Condition Value (Minutes)
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 bg-gray-700 border border-gray-600 text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400"
                      value={formData.conditionReason}
                      onChange={(e) => setFormData({...formData, conditionReason: e.target.value})}
                      placeholder="Enter minutes"
                    />
                  </div>
                )}

                {/* {modalType === 'edit' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-300 mb-2">
                      Required Hold (0.01 - 1.0)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      min="0.01"
                      max="1"
                      className="w-full px-3 py-2 bg-gray-700 border border-gray-600 text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400"
                      value={formData.reqHold}
                      onChange={(e) => setFormData({...formData, reqHold: parseFloat(e.target.value)})}
                    />
                  </div>
                )} */}
              </div>

              <div className="flex items-center gap-3 mt-8">
                <button
                  onClick={handleSubmit}
                  className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors font-medium"
                >
                  {modalType === 'add' ? 'Add Offer' : 'Update Offer'}
                </button>
                
                {modalType === 'edit' && (
                  <button
                    onClick={() => {
                      setShowModal(false)
                      setShowDeleteModal(true)
                    }}
                    className="px-4 py-2 bg-red-900 text-red-200 rounded-lg hover:bg-red-800 transition-colors font-medium"
                  >
                    <Trash2 size={16} />
                  </button>
                )}
                
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 border bg-gray-600 text-gray-300 rounded-lg hover:bg-gray-700 transition-colors font-medium"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
       <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-gray-800 rounded-xl shadow-xl max-w-md w-full border border-gray-700">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-red-100 rounded-lg">
                  <AlertTriangle className="text-red-600" size={20} />
                </div>
                <h3 className="text-lg font-bold text-gray-300">Confirm Deletion</h3>
              </div>
              
              <p className="text-gray-200 mb-6">
                Are you sure you want to delete <strong>{selectedOffer?.name}#{selectedOffer?.id}</strong>? 
                This action cannot be undone.
              </p>
              
              <div className="flex gap-3">
                <button
                  onClick={handleDelete}
                  className="flex-1 bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 transition-colors font-medium"
                >
                  Delete Offer
                </button>
                <button
                  onClick={() => setShowDeleteModal(false)}
                  className="flex-1 border bg-gray-600 py-2 px-4 rounded-lg hover:bg-gray-700 transition-colors font-medium"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default PlutoSuspectOffers